import React from 'react';
import { StoryblokReactComponent } from './componentsMap';
import { HtmlEmbedStoryblok } from '@/types/types-storyblok';
import { storyblokEditable } from '@storyblok/js';

export const StoryblokHtmlEmbed: StoryblokReactComponent<HtmlEmbedStoryblok> = ({ component }) => {
  if (!component.html) return null;
  return <div dangerouslySetInnerHTML={{ __html: component.html }} {...storyblokEditable(component)} />;
};
